import PrehledPlatbaApi from 'mc/lib/api/gen/pohledavky/PrehledPlatbaApi';
import {Filter} from 'mc/lib/filter';
import {InfiniteListActions} from 'mc/lib/list';
import * as StavPlatby from '../api/StavPlatby';

export const PLATBA_LIST_AREA = "platbaList";

function stavPlatbyToFilterFields(stavPlatby) {
    switch (stavPlatby) {
        case StavPlatby.NEVYPORADANO:
            return {
                vyrazeno: false,
                nevyporadano: true,
            };

        case StavPlatby.VSE:
            return {
                vyrazeno: null,
                nevyporadano: null,
            };

        case StavPlatby.VYRAZENO: {
            return {
                vyrazeno: true,
                nevyporadano: null,
            };
        }
    }

    return {
        vyrazeno: null,
        nevyporadano: null,
    };
}

export function filterPlatby(filter = {}) {
    return InfiniteListActions.filter(PLATBA_LIST_AREA, filter);
}

export function fetchPlatbyIfNeeded(force = false) {
    return InfiniteListActions.fetchIfNeeded(PLATBA_LIST_AREA, null, getPlatbyAllIds, getPlatbyRowsByIds, force);
}

function getPlatbyAllIds(parent, filter) {
    const {stavPlatby, datumPlatby, ...otherFilterFields} = Filter.purifyValues(filter);

    return PrehledPlatbaApi.findPrehledPlatbyIdsByFilter({
        ...stavPlatbyToFilterFields(stavPlatby),
        datumPlatbyOd: datumPlatby ? datumPlatby.datumOd : null,
        datumPlatbyDo: datumPlatby ? datumPlatby.datumDo : null,
        ...otherFilterFields,
    });
}

function getPlatbyRowsByIds(ids) {
    return PrehledPlatbaApi.findPrehledPlatbyByIds(ids);
}

export function loadMorePlatby() {
    return InfiniteListActions.loadMore(PLATBA_LIST_AREA, getPlatbyRowsByIds);
}

export function reloadPlatby() {
    return InfiniteListActions.reload(PLATBA_LIST_AREA, null, getPlatbyAllIds, getPlatbyRowsByIds,);
}

export function invalidatePlatby() {
    return InfiniteListActions.invalidate(PLATBA_LIST_AREA);
}
